import { IApplicationState } from '../../types/redux';
import { filterTagsByJsonQuery } from '../../utils/tags';

export const selectSearchTags = (state: IApplicationState) => {
  const { tags, nextJsonQuery } = state;

  // Нужно при удалении тегов.
  return filterTagsByJsonQuery(tags, nextJsonQuery);
};
